// extracted by mini-css-extract-plugin
export default {"customButton":"ButtonGroup_customButton__MMQ8c","active":"ButtonGroup_active__wcabe","groupcont":"ButtonGroup_groupcont__8Rye6"};